import { Button } from '@nextui-org/react';
import React from 'react';

type ConfirmationUIProps = {
  confirmationTittle: string;
  confirmationMessage: string;
  buttonAVariant?: 'solid' | 'light' | 'flat' | 'faded' | 'shadow' | 'ghost';
  buttonAColor?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  buttonA: string;
  onButtonAPress: () => void;
  buttonBVariant?: 'solid' | 'light' | 'flat' | 'faded' | 'shadow' | 'ghost';
  buttonBColor?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  buttonB: string;
  onButtonBPress: () => void;
};

export const ConfirmationUi = (props: ConfirmationUIProps) => {
  return (
    <div className='flex px-1 py-2 gap-2 flex-col'>
      <div className='text-small font-bold'>{props.confirmationTittle}</div>
      <div className='text-tiny'>{props.confirmationMessage}</div>
      <div className='flex flex-row gap-2 justify-end'>
        <Button
          variant={props.buttonAVariant || 'light'}
          color={props.buttonAColor || 'default'}
          onPress={props.onButtonAPress}
        >
          {props.buttonA}
        </Button>
        <Button
          variant={props.buttonBVariant || 'flat'}
          color={props.buttonBColor || 'primary'}
          onPress={props.onButtonBPress}
        >
          {props.buttonB}
        </Button>
      </div>
    </div>
  );
};
